import React from "react";
import { LoadingOutlined, FilePdfOutlined } from "@ant-design/icons";

interface FilePreviewProps {
  fileName: string;
  onPreview: () => void;
  onRemove: (e: React.MouseEvent) => void;
  loading?: boolean;
  styles: any;
}

export const FilePreview: React.FC<FilePreviewProps> = React.memo(
  ({ fileName, onPreview, onRemove, loading, styles }) => {
    return (
      <div className={styles.imagePreview}>
        <div
          className={styles.videoThumbWrapper}
          style={{ opacity: loading ? 0.6 : 1 }}
          onClick={onPreview}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "100%",
              gap: "8px",
              padding: "8px",
            }}
          >
            <FilePdfOutlined style={{ fontSize: "24px", color: "#ff4d4f" }} />
            <span
              style={{
                fontSize: "12px",
                color: "#262626",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: "100px",
              }}
            >
              {fileName}
            </span>
          </div>
        </div>
        <span className={styles.removeImage} onClick={onRemove}>
          ×
        </span>
        {loading && (
          <div className={styles.imageLoading}>
            <LoadingOutlined className={styles.blueIconSmall} />
          </div>
        )}
      </div>
    );
  }
);

FilePreview.displayName = "FilePreview";
